"use client"

import { useEffect } from "react"
import { installExpandMotion } from "@/lib/expand-motion"

/**
 * 挂载全站展开动效的运行时钩子（见 lib/expand-motion.ts）。
 * 只装监听、不渲染任何 DOM，放在根布局里全局生效。
 */
export function MotionProvider() {
  useEffect(() => installExpandMotion(), [])
  return null
}
